import { materityData } from './../../photos/data/maternity.data';
import { Component, OnInit } from '@angular/core';
import { categories } from '@data/models/category.model';
import { Image } from '@data/models/image.model';
import { Observable } from 'rxjs';
import { SEOService } from '@data/services/meta-data.service';
import { ServicesService } from '../services.service';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.scss'],
})
export class ServiceListComponent {
  images$: Observable<string[]>;
  categories = categories;
  info = {
    title: 'Services',
    subTitle: 'My Photography services',
  };

  constructor(
    private serviceService: ServicesService,
    private seoService: SEOService
  ) { }

  ngOnInit(): void {
    this.images$ = this.serviceService.getImages();
  }

  setSeoData(): void {
    const metaTitle = 'Services';
    const metaDescription =
      '"Capture timeless moments with Gill Juergens Photography! From heartwarming family portraits to the joy of newborn and maternity shoots, we specialize in preserving your precious memories. Trust us to beautifully document your love story with our professional wedding photography. Book your session now for unforgettable imagery that lasts a lifetime."';

    this.seoService.setMetaData(metaTitle, metaDescription);
  }
}
